import happyImage from '../../img/product/happy.png'
import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';

const fallAnimation = keyframes`
    0% {
        transform: translateY(-100vh) rotate(0deg);
    }
    100% {
        transform: translateY(100vh) rotate(360deg);
    }
`;

const generateRandomColor = () => `rgb(${Math.random() * 255},${Math.random() * 255},${Math.random() * 255})`;

const Paper = styled.div`
    position: absolute;
    width: 20px;
    height: 20px;
    background-color: ${generateRandomColor()};
    border-radius: 50%;
    transform-origin: 50% 50%;
    animation: ${fallAnimation} linear infinite;
`;


const Success = () => {
    const [papers, setPapers] = useState([]);
    const containerStyle = {
        textAlign: 'center',
        marginTop: '50px',
    };

    const headingStyle = {
        fontSize: '2em',
        color: '#1ca81c', 
        marginTop: '50px',
    };

    const messageStyle = {
        fontSize: '1.2em',
        marginBottom: '20px',
    };


    const detailsTextStyle = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    };

    useEffect(() => {
        const numPapers = 90; // Adjust the number of papers
        const newPapers = Array.from({ length: numPapers }, (_, index) => ({
            key: index,
            left: Math.random() * 100 + 'vw',
            duration: Math.random() * 2 + 1 + 's',
            color: generateRandomColor(),
        }));
        setPapers(newPapers);
    }, []);

    return (
        <div style={{ position: 'relative', width: '100vw', height: '70vh', overflow: 'hidden' }}>
                    <section className="product-details spad">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="product__details__text" style={{ ...containerStyle, ...detailsTextStyle }}>
                            <img src={happyImage} alt="" style={{ width: '171px', height: '120px' }} />
                            <h3 style={headingStyle}>
                            Commande passée avec succès
                            </h3>
                            <p style={messageStyle}>Nous vous appellerons pour confirmer votre commande.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
            
            {papers.map(paper => (
                <Paper
                    key={paper.key}
                    style={{ left: paper.left, animationDuration: paper.duration, backgroundColor: paper.color }}
                />
            ))}
        </div>
    );
};

export default Success;
